// Preview downloads come back as a blob, so an error message arrives as a blob too. Turn it back
// into the JSON the rest of the app expects.
const readBlobText = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });

export const unwrapBlobError = async (error: unknown): Promise<unknown> => {
  const response = (error as { response?: { data?: unknown } })?.response;
  if (response?.data instanceof Blob) {
    try {
      response.data = JSON.parse(await readBlobText(response.data));
    } catch {
      response.data = undefined;
    }
  }
  return error;
};
